export const MAINTYPE_SET = 'MAINTYPE_SET';
export const CHARTTYPE_SET = 'CHARTTYPE_SET';
export const CHARTCODE_SET = 'CHARTCODE_SET';